import _isEmpty from "lodash/isEmpty";
import { getCurrentDateTime } from "@/utils/helpers";
import { getUtmTags, getUserProperties } from "@/utils/userTrackingProperties";
import Auth from "./auth.js";

export default {
    mixins: [Auth],
    methods: {
        $_accountValidation(userData = {}, accountExists = true) {
            this.$refs["signUpForm"].$validator.errors.removeById("emailInUse");
            if (accountExists) {
                this.$refs["signUpForm"].$validator.errors.add({
                    id: "emailInUse",
                    field: "email",
                    msg: "This email is already in use"
                });
            } else {
                this.$_handleEmailAuth(userData);
            }
        },
        $_handleSuccessfullAuth(user = {}, method = "email") {
            // TODO Show the user a success notification
            this.$emit("auth-sucessfull", user);
            this.$store.dispatch("User/setToken", user.token);
            Cookies.set("token", user.token);
            if (
                process.env.NODE_ENV === "production" &&
                window.location.hostname.replace("www.", "") === "hibooks.com"
            ) {
                this.$_signUpTrackings(user, method);
            }
            const defaultRouteToGo = { name: "subscription-audiobooks" };
            if (this.useRouteHandler) {
                this.$_handleNextRoute(this.$route, defaultRouteToGo);
            }
        },
        $_signUpTrackings(userData = {}, method = "email") {
            const user = userData.user;
            const isEmailLogin = _isEmpty(user.facebook);
            const email = isEmailLogin
                ? user.email
                : user.facebook.email_address;
            // Leanplum first user configuration
            Leanplum.setUserId(user.id);
            const userAttributes = {
                email,
                backend_id: user.id,
                first_name: user.first_name
            };
            const firstTrackingEvent = getUserProperties(
                {
                    utm_tags: getUtmTags(this.$route.query),
                    method,
                    account_creation_date: getCurrentDateTime()
                }, { ...user }
            );
            Leanplum.setUserAttributes(userAttributes);
            Leanplum.track("web_account_created", firstTrackingEvent);
            // analytics first user configuration
            if (!_isEmpty(analytics)) {
                analytics.identify(user.id, firstTrackingEvent);
                analytics.track("web_account_created", firstTrackingEvent);
            }
        }
    }
};
